/**
 * User có phạm vi chat toàn công ty (IT / support).
 *
 * @param {{ chat_access?: string }|null|undefined} user
 * @returns {boolean}
 */
export function isChatAccessPublic(user) {
  return String(user?.chat_access || "") === "public";
}
